import {RESOURCE_TYPE, RESOURCE_TYPE_SINGULAR} from './Policy.types'

export interface SearchSuggestion {
  displayValue: string
  searchTerm: string
  resourceType: RESOURCE_TYPE
  resourceTypeSingular?: RESOURCE_TYPE_SINGULAR
  city?: string
  country?: string
  name?: string
  emailId?: string
}

export interface SearchUsersGroupsListItem {
  emailId: string
  name: string
}

export interface AnalyticsSearchPayloadType {
  searchTerm: string
}

export interface ResourceSearchItem {
  display_term: string
  search_term: string
  type: RESOURCE_TYPE
  city?: string
  country?: string
  name?: string
  emailId?: string
}

export enum ANALYTICS_VIEW {
  overview = 'overview',
}
